import styled from 'styled-components';
import bgImage from '../assets/bg.png'; // Importando a imagem do background

const Container = styled.div`
  background-image: url(${bgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export default Container;
